var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-upload",
    {
      staticClass: "upload-btn",
      attrs: {
        action: _vm.define.comUrl + _vm.url,
        headers: { Authorization: _vm.$store.getters.token },
        "on-success": _vm.handleSuccess,
        "before-upload": _vm.beforeUpload,
        "show-file-list": false,
      },
    },
    [
      _c(
        "el-button",
        {
          attrs: {
            type: _vm.buttonType,
            icon: "el-icon-upload2",
            loading: _vm.loading,
          },
        },
        [_vm._v(_vm._s(_vm.buttonText) + "\n  ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }